import { render, staticRenderFns } from "./copemon.vue?vue&type=template&id=015691b8&scoped=true&"
import script from "./copemon.vue?vue&type=script&lang=js&"
export * from "./copemon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015691b8",
  null
  
)

export default component.exports